import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { BackReplyModel } from '../_models/back-reply.model';
import { ValidarAspiranteResponseModel } from '../_models/validarAspiranteResponse.model';
import { CodigoActivacionResponse } from '../_models/codigoactivacionResponse.model';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ReferencesService {
  private readonly tiposTelefono: string = 'ConTiposTelefono';
  private readonly entidadesFinancieras: string = 'ConEntidadesFinancieras';
  private readonly tiposProductos: string = 'ConTiposProducto';
  private readonly validarAspiranteCuentaDigital: string =
    'ValidarAspiranteCuentaDigital';
  private readonly codigoActivacion: string = 'CodigoActivacion';
  url!: string;

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string
  ) {
    this.url = baseUrl + 'api/main/';
  }
  private get urlTiposTelefono() {
    return this.url + this.tiposTelefono;
  }
  private get urlEntidadesFinancieras() {
    return this.url + this.entidadesFinancieras;
  }
  private get urlTiposProductos() {
    return this.url + this.tiposProductos;
  }
  private get urlValidarAspiranteCuentaDigital() {
    return this.url + this.validarAspiranteCuentaDigital;
  }
  private get urlCodigoActivacion() {
    return this.url + this.codigoActivacion;
  }

  ConsultaTiposTelefono(body: any): Observable<BackReplyModel> {
    const endpointUrl = `${this.urlTiposTelefono}`;
    return this.http.post<BackReplyModel>(endpointUrl, body);
  }

  ConsultaEntidadesFinancieras(body: any): Observable<BackReplyModel> {
    const endpointUrl = `${this.urlEntidadesFinancieras}`;
    return this.http.post<BackReplyModel>(endpointUrl, body);
  }

  ConsultaTiposProductos(body: any): Observable<BackReplyModel> {
    const endpointUrl = `${this.urlTiposProductos}`;
    return this.http.post<BackReplyModel>(endpointUrl, body);
  }

  ConsultaValidarAspiranteCuentaDigital(
    body: any
  ): Observable<ValidarAspiranteResponseModel> {
    const endpointUrl = `${this.urlValidarAspiranteCuentaDigital}`;
    return this.http.post<ValidarAspiranteResponseModel>(endpointUrl, body);
  }

  ConsultaCodigoActivacion(body: any): Observable<CodigoActivacionResponse> {
    const endpointUrl = `${this.urlCodigoActivacion}`;
    return this.http.post<CodigoActivacionResponse>(endpointUrl, body);
  }
}
